import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PhoneNumberUpdateModalUI from './PhoneNumberUpdateModalUI.js'

class PhoneNumberUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      phoneNumber: this.props.account.phoneNumber || '',
      phoneNumberError: null,
    }
  }

  render() {
    return (
      <PhoneNumberUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(event) => {this.setState({ phoneNumber: event.target.value })}}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => {this.setState({ phoneNumberError: error })}}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    const phoneNumberRegex = /^[0-9]{10}$/
    if (!phoneNumberRegex.test(this.state.phoneNumber)) {
      this.setState({
        phoneNumberError: 'Phone number must be exactly 10 digits'
      })
      return
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
      phoneNumberError: null
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/updatePhone`,
      this.onSubmitCallback,
    {
        phoneNumber: this.state.phoneNumber
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default PhoneNumberUpdateModalSF
